import { ILayoutType } from 'src/interfaces';

export const mapAllLayoutTypes = (layoutTypes: unknown[]): ILayoutType[] => {
  return (
    layoutTypes?.map((layoutType: unknown) => {
      return mapLayoutType(layoutType);
    }) ?? []
  );
};

const mapLayoutType = (layoutType: any): ILayoutType => {
  return {
    id: layoutType.id,
    name: layoutType.name,
  };
};
